import {MediaUserOnlyInfoContent} from './content';
import {MediaUserOnlyInfoNotice} from './notice';
import {MediaUserOnlyInfoRoot} from './root';

export const mediaUserOnlyInfo = {
  root: MediaUserOnlyInfoRoot,
  notice: MediaUserOnlyInfoNotice,
  content: MediaUserOnlyInfoContent,
};
